export enum DEALER_CREATION_OPTION {
  UPDATE_DEALER_INFORMATION = 'updateDealerInformation',
  UPDATE_DEALER_LOCATION = 'updateDealerLocation',
}
